
export default [
    {
        path: '/',
        redirect: '/home',
        meta: {
            title: '数城科技'
        },
        component: () => import('../views/index/index.vue'),
        children: [
            {
                path: '/home',
                name: 'home',
                meta: {
                    title: '数城科技'
                },
                component: () => import('../views/home/home.vue')
            },{
                path: '/introduce',
                name: 'introduce',
                meta: {
                    title: '数城科技-公司介绍'
                },
                component: () => import('../views/introduce/introduce.vue')
            },{
                path: '/service',
                name: 'service',
                meta: {
                    title: '数城科技-业务板块'
                },
                component: () => import('../views/service/service.vue'),
            },{
                path: '/honor',
                name: 'honor',
                meta: {
                    title: '数城科技-荣誉资质'
                },
                component: () => import('../views/honor/honor.vue'),
            },{
                path: '/case',
                name: 'case',
                meta: {
                    title: '数城科技-项目案例'
                },
                component: () => import('../views/case/case.vue'),
            },{
                path: '/product',
                name: 'product',
                meta: {
                    title: '数城科技-公司产品'
                },
                component: () => import('../views/product/product.vue'),
            },{
                path: '/product-detail',
                name: 'product-detail',
                meta: {
                    title: '产品详情'
                },
                component: () => import('../views/product/product-detail.vue'),
            },
            {
                path: '/news',
                name: 'news',
                meta: {
                    title: '数城科技-新闻动态'
                },
                component: () => import('../views/news/news.vue')
            },{
                path: '/join',
                name: 'join',
                meta: {
                    title: '数城科技-招贤纳士'
                },
                component: () => import('../views/join/join.vue'),
            },{
                path: '/news-detail',
                name: 'news-detail',
                meta: {
                    title: '新闻动态'
                },
                component: () => import('../views/news/news-detail/news-detail.vue')
            },,{
                path: '/case-detail',
                name: 'case-detail',
                meta: {
                    title: '案例详情'
                },
                component: () => import('../views/case-detail/case-detail.vue')
            }, {
                path: 'join-us-detail',
                name: 'join-detail',
                meta: {
                    title: '招聘详情'
                },
                component: () => import('../views/join/detail/detail.vue')
            }
        ]
    }
];